


































import { Vue, Component, Prop } from "@/shared/vuepack";
import _ from "lodash";

@Component
export default class Pagination extends Vue {

  @Prop()
  page: number;

  @Prop()
  pageCount: number;

  @Prop()
  pageButtonRange: any[];

  @Prop()
  alwaysShowPageCount: boolean;

  previousPage () {
    const newPage = this.page - 1;
    this.switchPage(newPage);
  }

  switchPage (page) {
    this.$emit("switchPage", page);
  }

  nextPage () {
    const newPage = this.page + 1;
    this.switchPage(newPage);
  }

  get displayPaginationContainer (): boolean {
    return this.displayPagination || this.hasLeftSlotContent;
  }

  get hasLeftSlotContent (): boolean {
    return !!this.$slots["left-slot"];
  }

  get pageButtonsStartValue () {
    return this.page - 2 > 0 ? this.page - 2 : 1;
  }

  get buttonRange () {
    if (this.pageButtonRange !== undefined) {
      return this.pageButtonRange;
    } else {
      const endValue = this.page + 3 < this.pageCount ?
        (this.page + 3) : (this.pageCount + 1);
      return _.range(this.pageButtonsStartValue, endValue);
    }
  }

  get displayPagination () {
    return this.pageCount > 1 || this.alwaysShowPageCount;
  }

  get pageDescription (): string {
    return `Page ${this.page} of ${this.pageCount === 0 ? 1 : this.pageCount}`;
  }
}
